namespace TabAurous.OMS {
    export interface PaymentModeForm {
        Type: Serenity.LookupEditor;
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        OnlyForPos: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        CommissionAccount: Serenity.LookupEditor;
        CommissionPercent: Serenity.DecimalEditor;
    }

    export class PaymentModeForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PaymentMode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PaymentModeForm.init)  {
                PaymentModeForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(PaymentModeForm, [
                    'Type', w0,
                    'Code', w1,
                    'Name', w1,
                    'LedgerId', w0,
                    'OnlyForPos', w2,
                    'IsDisabled', w2,
                    'CommissionAccount', w0,
                    'CommissionPercent', w3
                ]);
            }
        }
    }
}
